import handleMethod from '../Utils/APIutils/handleMethod';

class StoreAPI {
  async getById(id) {
    return handleMethod({ type: 'GET', method: `api/gatewaycontagem/Stores/${id}` });
  }

  async getByClient(clientId, { city, status } = {}) {
    const params = new URLSearchParams();
    const fmt = (v) => (Array.isArray(v) ? v.filter(Boolean).join(',') : v);
    if (city && fmt(city)) params.set('city', fmt(city));
    if (status && fmt(status)) params.set('status', fmt(status));
    const queryString = params.toString() ? `?${params.toString()}` : '';
    return handleMethod({ type: 'GET', method: `api/gatewaycontagem/Stores/by-client/${clientId}${queryString}` });
  }

  async list({
    page = 1,
    itemsPerPage = 20,
    clientId,
    isActive,
    startDate,
    endDate,
    sortBy,
    sortDirection,
  } = {}) {
    const params = new URLSearchParams();

    params.set('page', page);
    params.set('itemsPerPage', itemsPerPage);

    if (clientId) params.set('clientId', clientId);
    if (typeof isActive === 'boolean') params.set('isActive', String(isActive));
    if (startDate) params.set('startDate', new Date(startDate).toISOString());
    if (endDate) params.set('endDate', new Date(endDate).toISOString());
    if (sortBy) params.set('sortBy', sortBy);
    if (sortDirection) params.set('sortDirection', sortDirection);

    return handleMethod({
      type: 'GET',
      method: `api/gatewaycontagem/Stores?${params.toString()}`,
    });
  }

  async create(data) {
    return handleMethod({ type: 'POST', method: 'api/gatewaycontagem/Stores', params: data });
  }

  async update(id, data) {
    return handleMethod({ type: 'PUT', method: `api/gatewaycontagem/Stores/${id}`, params: data });
  }

  async remove(id) {
    return handleMethod({ type: 'DELETE', method: `api/gatewaycontagem/Stores/${id}` });
  }
}

export const storeAPI = new StoreAPI();
